import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  textContainer: {
	maxWidth: "800px",
	textAlign: "center",
	margin: "0 auto",
  }
}));

export default function RegionHeader(props) {
    const { title, addtext=null, buttonValue, buttontext, handleButtonClick } = props;
	const classes = useStyles();
   
	return (
		<>
			<Typography className="stnbutton-container" variant="h6" component="h2">
				{title}
				{buttonValue &&
					<Button 
						className="stnbutton"
						value={buttonValue}
						variant="outlined" 
						size="small"
						onClick={handleButtonClick}
					>
						{buttontext}
					</Button>
				}
			</Typography>
			{addtext &&
				<div className={classes.textContainer}>
					<Typography sx={{lineHeight:"1.25",marginBottom:"1em"}}>
						{addtext}
					</Typography>
				</div>
			}
        </>
	);
}